import { t as ApiClient } from "./api-DjIIBiAX.js";
import { QueryClient } from "@tanstack/react-query";
import { QueryClient as QueryClient$1 } from "react-query";
//#region src/Api/types.ts
function isInstanceOfIErrorPayload(object) {
	return typeof object === "object" && object !== null && "status" in object && "message" in object;
}
//#endregion
//#region src/Api/reactQueryClient.ts
var defaultOptions = { queries: {
	queryFn({ queryKey }) {
		const [endpoint, options] = queryKey;
		const { searchParams } = options ?? {};
		return ApiClient.get(endpoint, { params: searchParams ?? options });
	},
	retry(failureCount, error) {
		return isInstanceOfIErrorPayload(error) && error.status === 500 && failureCount < 3;
	},
	refetchOnWindowFocus: false
} };
var v4DefaultOptions = { queries: {
	queryFn({ queryKey }) {
		const [endpoint, options] = queryKey;
		const { searchParams } = options ?? {};
		return ApiClient.get(endpoint, { params: searchParams ?? options });
	},
	retry(failureCount, error) {
		return isInstanceOfIErrorPayload(error) && error.status === 500 && failureCount < 3;
	},
	refetchOnWindowFocus: false
} };
var reactQueryClient = new QueryClient$1({ defaultOptions });
var v4ReactQueryClient = new QueryClient({ defaultOptions: { ...v4DefaultOptions } });
//#endregion
export { v4ReactQueryClient as n, reactQueryClient as t };

//# sourceMappingURL=Api-ABRWJg-R.js.map